import { render } from "./ReplyOpenDetailsButton.vue?vue&type=template&id=303b51a2&ts=true"
import script from "./ReplyOpenDetailsButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyOpenDetailsButton.vue?vue&type=script&lang=ts&setup=true"

import "./ReplyOpenDetailsButton.vue?vue&type=style&index=0&id=303b51a2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyOpenDetailsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "303b51a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('303b51a2', __exports__)) {
    api.reload('303b51a2', __exports__)
  }
  
  module.hot.accept("./ReplyOpenDetailsButton.vue?vue&type=template&id=303b51a2&ts=true", () => {
    api.rerender('303b51a2', render)
  })

}


export default __exports__